import BackIcon from 'assets/images/header/white-back.svg'
import { useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    return (
        <div className=" bg-green-1 w-full px-4 h-14 flex items-center justify-between sticky top-0 z-20 items-center">
            <button
                type="button"
                onClick={() => navigate(-1)}
                aria-label="بازگشت"
                className=" -m-2.5 p-2.5 active:scale-90"
            >
                <img src={BackIcon} alt="" className=" w-6 h-6" />
            </button>
            <p className=" text-white font-bold text-lg">{title}</p>
            <span className="w-6" />
        </div>
    )
}
